import React, { PureComponent } from 'react';
import { Icon, InfiniteTable } from 'appSrc/components/UI';
import TextTruncate from 'react-text-truncate';
import style from './styles/style.module.css';

// TODO: Switch this out for a copy of the ProductsTable file, which has the sorting attached.

class ContentTable extends PureComponent {
    render() {
        const { content } = this.props;

        return (
            <div className={ style.contentTable }>
                <InfiniteTable
                loadMore={ this.props.loadMore }
                elementHeight={ 70 }>
                    { this.arrayTableRows( content ) }
                </InfiniteTable>
            </div>
        );
    }


    arrayTableRows = ( content ) => {
        var markedIds = this.props.markedContent.map( item => item.id );
        var rows = content.map( ( content ) => {
            var author = content.author || {};
            return (
                <InfiniteTable.Row key={ content.id } className='dl-table-body'>
                    <InfiniteTable.Cell>
                        <TextTruncate text={ content.title }
                        line={ 2 } />
                    </InfiniteTable.Cell>
                    <InfiniteTable.Cell>
                        { ( content.content_type || {} ).name }
                    </InfiniteTable.Cell>
                    <InfiniteTable.Cell>
                        { author.displayName }
                    </InfiniteTable.Cell>
                    <InfiniteTable.Cell>
                        { content.categories.map( category => ( category || {} ).name ).join( ', ' ) }
                    </InfiniteTable.Cell>
                    <InfiniteTable.Cell className={ style.actionsCell }>
                        { markedIds.includes( content.id ) ?
                            'Added'
                            :
                            <Icon source='fontAwesome' className='dropdown' icon='fas/faPlus' style={ { color: '#6461ec', cursor: 'pointer' } } faSize='2x' onClick={ () => { this.props.onSubmit( content ); } } />
                        }
                    </InfiniteTable.Cell>
                </InfiniteTable.Row>
            );
        } );
        rows.unshift(
            (
                <InfiniteTable.Row key='-1' className='dl-table-head'>
                    <InfiniteTable.Cell>
                        Title
                    </InfiniteTable.Cell>
                    <InfiniteTable.Cell>
                        TYPE
                    </InfiniteTable.Cell>
                    <InfiniteTable.Cell>
                        USER
                    </InfiniteTable.Cell>
                    <InfiniteTable.Cell>
                        CATEGORY
                    </InfiniteTable.Cell>
                    <InfiniteTable.Cell>ADD</InfiniteTable.Cell>
                </InfiniteTable.Row>
            )
        );

        return rows;
    }
}
ContentTable.defaultProps = {
    onSubmit: () => {},
    markedContent: [],
};

export default ContentTable;
